import { AfterViewInit, Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { publicHelpers } from 'globals/helpers/public-helpers';
import { SliderImage } from 'globals/store/publish.data';
import { IconComponent } from '../icon/icon.component';
import { SliderImageComponent } from './slider-image.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'slider-images',
    template: `
<ng-container *ngIf="!!maxWidth">
  <div style="flex:1;"></div>
  <div class="arrow-holder">
    <icon *ngIf="!!position" [icon]="'arrow_back'" (click)="goBack()"></icon>
  </div>
  <div class="images-holder" [style.width]="((maxWidth - 1)*SPACING + 360)+'px'" >
    <slider-image *ngFor="let image of sliderImages; index as i;"
      [sliderImage]="image" 
      [style.transition]="transitionTime + 's ease'" 
      [style.left]="(i*SPACING - position*SPACING) + 'px'" 
    ></slider-image>
  </div>
  <div class="arrow-holder">
    <icon *ngIf="position < sliderImages.length - maxWidth" class="forward" [icon]="'arrow_back'" (click)="goForward()"></icon>
  </div>
  <div style="flex:1;"></div>
</ng-container>
  `,
    styles: [`
  :host { display: flex; justify-content: center; width: 100%; max-width: 1200; height: 300px; }
  .arrow-holder { display: flex; min-width: 50px; cursor: pointer; }
  icon.forward { transform: rotate(180deg); }
  icon { margin: auto; color: var(--primary); }
  .images-holder { display: flex; flex-wrap: wrap; justify-content: center; text-align: center; overflow: hidden; position: relative; height: 300px; }
  slider-image { position: absolute; }

`],
    standalone: true,
    imports: [IconComponent, SliderImageComponent, CommonModule],
})
export class SliderImagesComponent implements OnInit, OnChanges, AfterViewInit {
  maxWidth: number
  @Input() pauseMS = 7000
  @Input() baseTransitionTime = 0.5
  transitionTime = 0.5
  publicHelpers = publicHelpers
  SPACING = 400
  position = 0
  timeoutId

  @Input() sliderImages: SliderImage[] = []

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.resize()
  }

  constructor(public element: ElementRef) {
    
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.sliderImages.currentValue) this.sliderImages = changes.sliderImages.currentValue.filter(i => !!i.imageUrl)
    this.resize()
  }

  ngAfterViewInit() {
    setTimeout(() => this.resize(), 1000)
  }

  resize() {
    window['element'] = this.element
    const width = this.element.nativeElement.clientWidth
    const maxWidth = width > 1299 ? 3 : width > 899 ? 2 : 1
    this.maxWidth = Math.min(maxWidth, this.sliderImages.length)
  }


  ngOnInit() {
    this.tick()
  }

  goBack() {
    this.position -= 1
    this.tick()
  }

  goForward() {
    this.position += 1
    this.tick()
  }

  tick() {
    if (this.timeoutId) clearTimeout(this.timeoutId)
    this.timeoutId = setTimeout(() => {
      if (this.sliderImages.length > this.maxWidth) {
        const currentIndex = this.position
        const maxIndex = this.sliderImages.length - this.maxWidth
        const newIndex = currentIndex + 1
        this.position = newIndex > maxIndex ? 0 : newIndex
        this.transitionTime = newIndex > maxIndex ? this.baseTransitionTime * (this.sliderImages.length - this.maxWidth) : this.baseTransitionTime
      }
      this.tick()
    }, this.pauseMS)
  }

}